import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as TrackerFeatureState from './tracker.state';

export const selectTrackerState =
  createFeatureSelector<TrackerFeatureState.TrackerState>(
    TrackerFeatureState.trackerFeatureKey
  );

export const selectVideoUsage = createSelector(
  selectTrackerState,
  (state) => state.videoUsage
);

export const selectInterestSurveyTracker = createSelector(
  selectTrackerState,
  (state) => state.interestSurveyTracker
);
